var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LegendTag"},[_c('span',{staticClass:"LegendTag__dot",style:(_vm.dotStyle)}),_c('span',{staticClass:"LegendTag__text"},[_vm._v(_vm._s(_vm.label)+": "+_vm._s(_vm.percent)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }